import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 參數
 */
export interface VerifyMailCodeReq {
    code: string;
}

/**
 * @todo Api 回傳值
 */
export interface VerifyMailCodeResp extends GeneralResp {
    isReachedVerifyMaxTry: boolean;
}

/**
 * @todo 驗證簡訊驗證碼
 */
const VerifyMailCode = (data: VerifyMailCodeReq): Promise<VerifyMailCodeResp> => {
    const url = RouteUrlList.API_VerifyMailCode.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<VerifyMailCodeResp>) => {
        return res.data;
    });
};

export default VerifyMailCode;
